import React, { useState, useEffect } from 'react';
import styles from './queueQR.module.scss';
import QRCode from 'qrcode.react';
import { Picker, Toast } from 'antd-mobile-v5';
import { ApiCore } from '../../../api';
const api = new ApiCore();
const env = process.env.REACT_APP_ENV;


const QueueQR = (props) => {

    const [wxUrl, setWxUrl] = useState('');
    const [groupColumns, setGroupColumns] = useState([]) //患者分组列表
    const [selectGroup, setSelectGroup] = useState(null)  //患者所选分组


    useEffect(() => {
        getGroup();
    }, [])

    const getGroup = () => {
        api.getGroupSelfSelect().then((res) => {
            if (res.code === 0) {
                let groupColumns = res.data.map((item) => {
                    return {
                        label: item.name,
                        value: item.code
                    }
                })
                setGroupColumns(groupColumns)
                if (groupColumns.length > 0) {
                    getWxMiniProgramUrl(groupColumns[0].value)
                    setSelectGroup(groupColumns[0])
                }
            } else {
                Toast.show({
                    content: res.message
                })
            }
        })
    }


    const getWxMiniProgramUrl = (groupCode) => {
        let token = sessionStorage.getItem('token');
        if (token) {
            let mToken = JSON.parse(token);
            return new Promise((resolve) => {

                let envVersion = 'release';
                // 开发环境 开发版
                if (env === 'development') {
                    envVersion = 'trial';
                }
                // 测试环境 体验版
                else if (env === 'test') {
                    envVersion = 'trial';
                }
                // 生产环境 正式版
                else if (env === 'production') {
                    envVersion = 'release';
                }


                api.apiAppSecretGenerateUrl({
                    appCode: 'APP001',
                    envVersion: envVersion,
                    path: 'pages/patient/patient',
                    query: `groupCode=${groupCode}&doctorCode=${mToken.userCode}&tenantCode=${mToken.tenantCode}`,
                }).then((res) => {
                    if (res.code == 0) {
                        let _data = res.data || '';
                        setWxUrl(_data);
                    }
                    resolve();
                });
            });
        }
    }


    return (
        <div className={styles.addAssistance_content}>
            <div className={styles.qr_code_wrap}>

                <div className={styles.qr_code_container}>
                    <div className={styles.circular_left}></div>
                    <div className={styles.circular_right}></div>
                    <div className={styles.dashed_line}></div>
                    <div className={styles.qr_code_img_title}>
                        {selectGroup ? selectGroup.label : '请选择患者分组'}
                    </div>
                    <div className={styles.qr_code_img_container}>
                        <div className={styles.qr_code_border_lt}></div>
                        <div className={styles.qr_code_border_tl}></div>
                        <div className={styles.qr_code_border_rt}></div>
                        <div className={styles.qr_code_border_tr}></div>
                        <div className={styles.qr_code_border_lb}></div>
                        <div className={styles.qr_code_border_bl}></div>
                        <div className={styles.qr_code_border_rb}></div>
                        <div className={styles.qr_code_border_br}></div>
                        {
                            wxUrl ?
                                <QRCode
                                    id="queue_qr"
                                    className={styles.qr_code_img_content}
                                    value={wxUrl}  //value参数为生成二维码的链接
                                    size={188} //二维码的宽高尺寸
                                    fgColor="#000000"  //二维码的颜色
                                />
                                :
                                <div className={styles.qr_code_img_content}>
                                </div>
                        }

                    </div>
                    <div className={styles.patientGroup}>
                        <div className={styles.patientName}>患者分组</div>
                        <div className={styles.selectGroup}>
                            <div
                                className={styles.selectGroup_item}
                                onClick={async () => {
                                    const value = await Picker.prompt({
                                        columns: [groupColumns],
                                    })
                                    let Index = groupColumns.findIndex((v) => v.value == value?.toString())
                                    if (Index > -1) {
                                        setSelectGroup(groupColumns[Index])
                                        getWxMiniProgramUrl(groupColumns[Index].value)
                                    }
                                }}
                            >
                                {selectGroup ? selectGroup.label : '请选择患者分组'}
                            </div>
                            <div className={styles.item_arrow}> </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default QueueQR